import Chart from 'chart.js/auto';

function getNiceChartLabel(value) {
    let price = parseFloat(value).toFixed(2);
    return '£' + price + '/' + priceChart.unit;
}

document.querySelector('.product__link[href="#priceHistory"]')?.addEventListener('click', function (e) {
    e.preventDefault();
    document.getElementById('priceHistory')?.scrollIntoView({ behavior: 'smooth' });
});


document.addEventListener('DOMContentLoaded', function () {
    const canvas = document.querySelector('.product__canvas');

    const lowestPoint = Math.min(...priceChart.data);
    const highestPoint = Math.max(...priceChart.data);
    Chart.defaults.color = '#3C4B58';
    Chart.defaults.font.size = 11;

    new Chart(canvas, {
        type: 'line',
        data: {
            labels: priceChart.labels,
            datasets: [{
                data: priceChart.data,
                borderWidth: 2,
                tension: 0.3,
                fill: true,
                borderColor: '#E85F24',
                backgroundColor: '#E85F240D'
            }]
        },
        options: {
            scales: {
                y: {
                    beginAtZero: false,
                    min: lowestPoint - .5,
                    max: highestPoint + .5,
                    ticks: {
                        callback: getNiceChartLabel,
                    }
                },
                x: {
                    ticks: {
                        autoSkip: true,
                        maxRotation: 0,
                        minRotation: 0,
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false, // Disable default tooltips
                    external: (context) => {
                        // context contains all tooltip information
                        const { chart, tooltip } = context;
                        const tooltipEl = document.querySelector('.product__chart-tooltip');

                        // Hide if no tooltip
                        if (tooltip.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set text or HTML content inside tooltipEl based on the hovered item
                        // Example for a single dataset
                        if (tooltip.body) {
                            const bodyLines = tooltip.body.map(b => b.lines);
                            tooltipEl.innerHTML = getNiceChartLabel(bodyLines.toString());
                        }

                        // Calculate and set position
                        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.left = positionX + tooltip.caretX + 'px';
                        tooltipEl.style.top = positionY + tooltip.caretY + 'px';
                    }
                },
            }
        }
    });
});

